export default __webpack_public_path__ + "static/media/notification.d8450737.svg";